import { SYSTEM_HELP } from '@confluence/web-item-location/entry-points/webFragmentLocations';
import { preloadWebItemLocation } from '@confluence/web-item-location/entry-points/preloadWebItemLocation';
import { HelpPanelQuery } from '@confluence/in-product-help/entry-points/HelpPanelQuery.graphql';
import { waitForAllReturnWhenError } from '@confluence/query-preloader-tools/entry-points/waitForAllReturnWhenError';
import { query } from '@confluence/query-preloader-tools/entry-points/graphql';

export const preloadHelpMenu = () => {
	return waitForAllReturnWhenError([
		preloadWebItemLocation({ location: SYSTEM_HELP }),
		/* @ts-expect-error -- http://go/cfe-use-relay-artifacts */
		query({ query: HelpPanelQuery }),
	]);
};
